import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { registerLicense } from '@syncfusion/ej2-base';

import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'material-symbols';

import './assets/css/style.css';


registerLicense('Ngo9BigBOggjHTQxAR8/V1JFaF5cX2BCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH9eeHRcRWleVUN2WkJWYEg=');

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

import routes from './routes'
  
const router = new VueRouter({
  mode: 'history',
  routes  
})

Vue.filter('splitNumber', function (value) {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
 




 